import { render, staticRenderFns } from "./CustomModalComponent.vue?vue&type=template&id=32569e4c&"
import script from "./CustomModalComponent.vue?vue&type=script&lang=js&"
export * from "./CustomModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports